import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintenanceManBindQrCode
    (qrCode, deviceId, socketNum) {
    return maintainRequest.post(`/device/maintenanceMan/qrcode/bindQrCode/${qrCode}/${deviceId}/${socketNum}`)
}
